module.exports = __webpack_public_path__ + "static/media/r.d5826506.png";